'use strict';

exports.__esModule = true;
exports.mapSpecialtyToSchemaMedicalSpecialty = undefined;

var _doctifyUtils = require('doctify-utils');

var mapping = {
	'dermatology': { name: 'Dermatology', type: 'MedicalSpecialty' },
	'obstetrics & gynaecology': { name: 'Obstetric', type: 'MedicalSpecialty' },
	'general practice': { name: 'PrimaryCare', type: 'MedicalSpecialty' },
	'orthopaedic surgery': { name: 'Musculoskeletal', type: 'MedicalSpecialty' },
	'paediatrics': { name: 'Pediatric', type: 'MedicalSpecialty' },
	'ear nose & throat surgery': { name: 'Otolaryngologic', type: 'MedicalSpecialty' },
	'acupuncture': { name: 'TraditionalChinese', type: 'MedicalSpecialty' },
	'allergy medicine': { name: 'CommunityHealth', type: 'MedicalSpecialty' },
	'anaesthetics': { name: 'Anesthesia', type: 'MedicalSpecialty' },
	'audiology': { name: 'Otolaryngologic', type: 'MedicalSpecialty' },
	'breast surgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'cardiology': { name: 'Cardiovascular', type: 'MedicalSpecialty' },
	'cardiothoracic surgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'chiropractic': { name: 'Chiropractic', type: 'MedicalSpecialty' },
	'clinical genetics': { name: 'Genetic', type: 'MedicalSpecialty' },
	'cosmetic medicine': { name: 'PlasticSurgery', type: 'MedicalSpecialty' },
	'dental hygienist': { name: 'Dentistry', type: 'MedicalSpecialty' },
	'dentistry': { name: 'Dentistry', type: 'MedicalSpecialty' },
	'dietician': { name: 'DietNutrition', type: 'MedicalSpecialty' },
	'endocrinology': { name: 'Endocrine', type: 'MedicalSpecialty' },
	'fertility medicine': { name: 'CommunityHealth', type: 'MedicalSpecialty' },
	'gastroenterology': { name: 'Gastroenterologic', type: 'MedicalSpecialty' },
	'general practice (video consultation)': { name: 'PrimaryCare', type: 'MedicalSpecialty' },
	'general surgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'genito-urinary medicine': { name: 'Urologic', type: 'MedicalSpecialty' },
	'geriatric medicine': { name: 'Geriatric', type: 'MedicalSpecialty' },
	'haematology': { name: 'Hematologic', type: 'MedicalSpecialty' },
	'holistic therapy': { name: 'Ayurvedic', type: 'MedicalSpecialty' },
	'homeopathy': { name: 'Homeopathic', type: 'MedicalSpecialty' },
	'imaging (scans)': { name: 'Radiography', type: 'MedicalSpecialty' },
	'nephrology (renal medicine)': { name: 'Renal', type: 'MedicalSpecialty' },
	'neurology': { name: 'Neurologic', type: 'MedicalSpecialty' },
	'neurophysiology': { name: 'Neurologic', type: 'MedicalSpecialty' },
	'neurosurgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'nutrition': { name: 'DietNutrition', type: 'MedicalSpecialty' },
	'nutritionist': { name: 'DietNutrition', type: 'MedicalSpecialty' },
	'oncology': { name: 'Oncologic', type: 'MedicalSpecialty' },
	'ophthalmology': { name: 'Optometric', type: 'MedicalSpecialty' },
	'oral & maxillofacial surgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'osteopathy': { name: 'Osteopathic', type: 'MedicalSpecialty' },
	'paediatric surgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'pain management': { name: 'OccupationalTherapy', type: 'MedicalSpecialty' },
	'physiotherapy': { name: 'Physiotherapy', type: 'MedicalSpecialty' },
	'plastic surgery': { name: 'PlasticSurgery', type: 'MedicalSpecialty' },
	'podiatry': { name: 'Podiatric', type: 'MedicalSpecialty' },
	'psychiatry': { name: 'Psychiatric', type: 'MedicalSpecialty' },
	'psychology': { name: 'Psychiatric', type: 'MedicalSpecialty' },
	'psychotherapy': { name: 'Psychiatric', type: 'MedicalSpecialty' },
	'radiology': { name: 'Radiography', type: 'MedicalSpecialty' },
	'respiratory medicine': { name: 'Pulmonary', type: 'MedicalSpecialty' },
	'rheumatology': { name: 'Rheumatologic', type: 'MedicalSpecialty' },
	'sexual health': { name: 'Urologic', type: 'MedicalSpecialty' },
	'sport & exercise medicine doctor': { name: 'Musculoskeletal', type: 'MedicalSpecialty' },
	'traditional chinese medicine': { name: 'TraditionalChinese', type: 'MedicalSpecialty' },
	'travel medicine': { name: 'CommunityHealth', type: 'MedicalSpecialty' },
	'urology': { name: 'Urologic', type: 'MedicalSpecialty' },
	'vascular surgery': { name: 'Surgical', type: 'MedicalSpecialty' },
	'weight loss & bariatric surgery': { name: 'Surgical', type: 'MedicalSpecialty' }
}; /* eslint key-spacing:0 */

var mapSpecialtyToSchemaMedicalSpecialty = exports.mapSpecialtyToSchemaMedicalSpecialty = function mapSpecialtyToSchemaMedicalSpecialty(specialty) {
	mapping.__default__ = { name: specialty, type: 'MedicalSpecialty' };
	return (0, _doctifyUtils.switchCase)(specialty.toLowerCase(), mapping) || {};
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-generator/lib/transformers/medical-specialty.js
// module id = 2364
// module chunks = 0